import { r as registerInstance, h, H as Host } from './index-ce7d0cf1.js';
import { i as initMyTrumpfNotificationBackend } from './backend-8895d157.js';
import './index-b34238aa.js';
import './index-5a73d8b4.js';
import './debounce-9c93e0a1.js';

const MytrumpfNotificationService = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.debug = false;
        this.environment = "prod";
        this.clientId = undefined;
        this.clientName = undefined;
        this.pollInterval = undefined;
    }
    componentWillLoad() {
        const prod = !(this.environment === "qa" || this.environment === "dev");
        this.issuer = prod ? "https://identity.trumpf.com" : "https://identity-s.trumpf.com";
        initMyTrumpfNotificationBackend({
            environment: this.environment,
            authClientName: this.clientName,
            pollInterval: this.pollInterval,
            debug: this.debug
        });
    }
    render() {
        return (h(Host, { key: '65d82aa14b31e8b6bfacd6d093bd15b5512cf131' }, h("ux-u-silent-auth", { key: '52bbc1c4ecdd7a36f91e31881d129db5fc092cda', "client-id": this.clientId, "client-name": this.clientName, issuer: this.issuer, scope: "openid", debug: this.debug })));
    }
};

export { MytrumpfNotificationService as uxc_u_mytrumpf_notification_service };

//# sourceMappingURL=uxc-u-mytrumpf-notification-service.entry.js.map